import ArticleIcon from "@mui/icons-material/Article";
import CalculateIcon from "@mui/icons-material/Calculate";
import DownloadIcon from "@mui/icons-material/Download";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import { Button, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import { Link } from "react-router-dom";
import { getPackageDoc } from "../../admin/packages/packagesApi";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import DownloadFileButton from "../../components/downloadFileButton/DownloadFileButton";
import { useAuthState } from "../../misc/useAuthState";
import { useDownloadImages } from "../../misc/useDownloadImages";
import type { PublicPackageResponse } from "../../publicPackages/publicPackagesApi";
import { userFriendlyPackageId } from "../userFriendltPackageId";
import type { FormatType } from "./FormatSelector";

const formatMap = {
  plan: "PLAN",
  description: "DESCRIPTION",
} as const;

export function PackageActions(props: { forPackage: PublicPackageResponse; format: FormatType }) {
  const { download } = useDownloadImages();
  const { images } = props.forPackage.media;
  const { enqueueSnackbar } = useSnackbar();

  const { context } = useAuthState();
  const isCustomer = context?.role === "CUSTOMER";

  return (
    <Stack
      direction="row"
      spacing={1.5}
      useFlexGap
      sx={{
        flexWrap: "wrap",
      }}
    >
      <AsyncLoadingButton
        variant="outlined"
        color="inherit"
        startIcon={<DownloadIcon />}
        sx={{ borderRadius: 6 }}
        disabled={images.length === 0}
        onClick={async () => {
          await download(images.map((i) => ({ name: i.name, url: i.original.url })));
        }}
      >
        Pobierz zdjęcia
      </AsyncLoadingButton>
      {isCustomer && (
        <DownloadFileButton
          buttonText="Pobierz program"
          startIcon={<ArticleIcon />}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: 6 }}
          filename={`${props.forPackage.name}.docx`}
          options={[
            {
              name: "",
              apiDefinition: async () => {
                const blob = await getPackageDoc(props.forPackage.id.id, formatMap[props.format]);
                if (!blob) {
                  throw new Error("Brak dokumentu pakietu");
                }
                return blob;
              },
            },
          ]}
          onError={() => enqueueSnackbar("Nie udało się pobrać pliku z programem", { variant: "error" })}
        />
      )}
      <Button
        variant="outlined"
        color="inherit"
        component={Link}
        to={`/calculations/new?fromPackage=${props.forPackage.id.id}`}
        startIcon={<CalculateIcon />}
        sx={{ borderRadius: 6 }}
      >
        Wyceń pakiet
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ShoppingCartCheckoutIcon />}
        sx={{ borderRadius: 6 }}
        disableElevation
        component={Link}
        to={`/e-commerce?query=${userFriendlyPackageId(props.forPackage)}`}
      >
        E-commerce
      </Button>
    </Stack>
  );
}
